var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSearchIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.65627 0.989746C3.03867 0.989746 0.916687 3.11173 0.916687 5.72933C0.916687 8.34693 3.03867 10.4689 5.65627 10.4689C8.27387 10.4689 10.3959 8.34693 10.3959 5.72933C10.3959 3.11173 8.27387 0.989746 5.65627 0.989746ZM0.104187 5.72933C0.104187 2.663 2.58994 0.177246 5.65627 0.177246C8.7226 0.177246 11.2084 2.663 11.2084 5.72933C11.2084 7.11627 10.6998 8.38444 9.85899 9.35752L11.631 11.1296C11.7897 11.2882 11.7897 11.5454 11.631 11.7041C11.4724 11.8627 11.2152 11.8627 11.0565 11.7041L9.28447 9.93205C8.31138 10.7729 7.04321 11.2814 5.65627 11.2814C2.58994 11.2814 0.104187 8.79566 0.104187 5.72933Z",
    fill: "#7A8191"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearchIcon);
export default __webpack_public_path__ + "static/media/search-icon.11110a2b70456b622c23d522b8bd20df.svg";
export { ForwardRef as ReactComponent };